/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
import React from 'react';

/**
 * @description
 * Reduce rule params array to string
 *
 * @param {Array} paramValues - Params.
 * @returns {string} Reduced rule params.
 */
const reduceRuleParams = paramValues => {
  let acc = '';
  paramValues.forEach(({ key, value }) => {
    acc += ` &nbsp &nbsp &nbsp &nbsp ${key}: ${value} <br/>`;
  });
  return acc;
};

export default function printParams(element, classes) {
  return element.params.map((param, key) => (
    <div
      key={`pr-param-${element.id}-${key}`}
      className={classes.matchedRule}
      dangerouslySetInnerHTML={{
        __html:
          param.values.length > 0
            ? `<h6>${param.action}</h6> ${reduceRuleParams(param.values)}`
            : null,
      }}
    />
  ));
}
